module.exports=function(scope){ return `String deviceLicenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";
String serverLicenseKey = "<THIS_KEY_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";
String encryptionKey = "<THIS_IS_YOUR_ENCRYPTION_KEY>";

// (Optional) Create configuration object that sets custom directory for the FaceTec SDK to unpack temporary resource files. Compatible with both Key types.
ZoomInitializeConfig initConfig = new ZoomInitializeConfig();
config.workingDirectoryPath = "<THIS_IS_YOUR_CUSTOM_DIRECTORY_PATH>";

// Initialize using optional parameter to configure custom working directory
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - serverLicenseKey - This is your Server Key . You can get your Server Key  here: https://dev.facetec.com/zoomsdk/#/account
// @param - encryptionKey - This is the contents of your ZoomServer_private.pem as a string
// @param - initConfig - (Optional) This is the created ZoomInitializeConfig object, whose workingDirectoryPath property is a string that points to a custom directory where FaceTec SDKs should unpack its temporary resource files upon initialization
//
// @throws - initException - This is a ZoomInitException object that is thrown if initialization was not successful. This contains the ZoomInitError object as a property
//
try {
    ZoomAuthenticationInstance zoomInstance = ZoomAuthentication.initialize(deviceLicenseKeyIdentifier, serverLicenseKey, encryptionKey, initConfig);
}
catch (ZoomInitException initException) {
    // Handle exception
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/server/00-initialize-dev.java.tpl